import { Metadata } from 'next'
import { HomeMetaData } from './home'

export const BaseMetadata: Metadata = {
  metadataBase: new URL('https://aviagames.com'),
  title: HomeMetaData.title,
  description: HomeMetaData.description,
  openGraph: HomeMetaData.openGraph,
  robots: process.env.NEXT_PUBLIC_ROBOTS_META || 'noindex, nofollow',
  verification: { google: 'lUZaC7g2WeLjZTNZzBUzyp2F5I7rN4-zzuFeZavuv34' },
}
